import { render } from "./salaryReport.vue?vue&type=template&id=64d6d207&scoped=true"
import script from "./salaryReport.vue?vue&type=script&lang=js"
export * from "./salaryReport.vue?vue&type=script&lang=js"

import "./salaryReport.vue?vue&type=style&index=0&id=64d6d207&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64d6d207"]])

export default __exports__